/**
 * @generated SignedSource<<eed90d0cc318fb7ef14d5a1642e3426a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "token"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "token",
        "variableName": "token"
      }
    ],
    "concreteType": "Verify",
    "kind": "LinkedField",
    "name": "verifyToken",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "payload",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "authApiService_verifyTokenMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "authApiService_verifyTokenMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0fbd491e72dc3cae94c15addf0d6e16f",
    "id": null,
    "metadata": {},
    "name": "authApiService_verifyTokenMutation",
    "operationKind": "mutation",
    "text": "mutation authApiService_verifyTokenMutation(\n  $token: String!\n) {\n  verifyToken(token: $token) {\n    payload\n  }\n}\n"
  }
};
})();

node.hash = "1a9ea1b124cc6826b1fc908ad452b687";

module.exports = node;
